<template>
  <prona-wizard-step class="wizard-step-nims-contactData">
    <p-request-alert v-model="error"></p-request-alert>
    <p-progress-linear v-if="isLoading" class="my-5" indeterminate></p-progress-linear>
    <div v-else>
      <div class="nims-contactData">
        <p-row>
          <p-col xs12 md6>
            <p-select v-model="wizardData.contactData.salutation" :label="$t('core.address.salutation')" :items="salutations" required></p-select>
          </p-col>
        </p-row>
        <p-row>
          <p-col>
            <p-text-field v-model="wizardData.contactData.firstName" :label="$t('core.address.firstName')" required></p-text-field>
          </p-col>
          <p-col>
            <p-text-field v-model="wizardData.contactData.lastName" :label="$t('core.address.lastName')" required></p-text-field>
          </p-col>
        </p-row>
        <p-row>
          <p-col xs12 md10>
            <p-text-field v-model="wizardData.contactData.street" :label="$t('core.address.street')" required></p-text-field>
          </p-col>
          <p-col xs12 md2>
            <p-text-field v-model="wizardData.contactData.houseNumber" :label="$t('core.address.houseNumber')" required></p-text-field>
          </p-col>
        </p-row>
        <p-row>
          <p-col xs12 md6>
            <p-text-field v-model="wizardData.contactData.additionToAddress" :label="$t('core.address.addressLine1')"></p-text-field>
          </p-col>
        </p-row>
        <p-row>
          <p-col xs12 md3>
            <p-text-field v-model="wizardData.contactData.zipCode" :label="$t('core.address.postalCode')" required></p-text-field>
          </p-col>
          <p-col xs12 md9>
            <p-text-field v-model="wizardData.contactData.city" :label="$t('core.address.city')" required></p-text-field>
          </p-col>
        </p-row>
      </div>
      <div class="nims-gardenAdress">
        <p-row>
          <p-col>
            <p-checkbox v-model="wizardData.isGardenAddressNotContactDataAddress" :label="$t('pronatura.widget.nimswizard.gardenAddress.isGardenAddressNotContactDataAddress')"></p-checkbox>
            <div v-if="wizardData.isGardenAddressNotContactDataAddress">
              <p-row>
                <p-col xs12 md10>
                  <p-text-field v-model="wizardData.gardenAddress.street" :label="$t('core.address.street')" required></p-text-field>
                </p-col>
                <p-col xs12 md2>
                  <p-text-field v-model="wizardData.gardenAddress.houseNumber" :label="$t('core.address.houseNumber')" required></p-text-field>
                </p-col>
              </p-row>
              <p-row>
                <p-col xs12 md3>
                  <p-text-field v-model="wizardData.gardenAddress.zipCode" :label="$t('core.address.postalCode')" required></p-text-field>
                </p-col>
                <p-col xs12 md9>
                  <p-text-field v-model="wizardData.gardenAddress.city" :label="$t('core.address.city')" required></p-text-field>
                </p-col>
              </p-row>
            </div>
          </p-col>
        </p-row>
      </div>
      <div class="nims-communicationData">
        <p-row>
          <p-col>
            <h3>{{ $t('pronatura.widget.nimswizard.communicationData.title') }}</h3>
            <p-row>
              <p-col xs12 md6>
                <p-text-field v-model="wizardData.communicationData.email" :label="$t('pronatura.widget.nimswizard.communicationData.email')" required></p-text-field>
              </p-col>
            </p-row>
            <p-row>
              <p-col xs12 md6>
                <p-phone-field v-model="wizardData.communicationData.phoneNumber" :label="$t('pronatura.widget.nimswizard.communicationData.phoneNumber')" required></p-phone-field>
              </p-col>
            </p-row>
            <p-row>
              <p-col xs12 md9>
                <p-text-field v-model="wizardData.communicationTime" :label="$t('pronatura.widget.nimswizard.communicationData.communicationTime')" required></p-text-field>
              </p-col>
            </p-row>
            <p-row>
              <p-col xs12 md6>
                <p-select v-model="wizardData.nimSLanguageId" :label="$t('pronatura.widget.nimswizard.communicationData.nimSLanguageId')" :items="wizardData.nimsLanguages" required></p-select>
              </p-col>
            </p-row>
          </p-col>
        </p-row>
      </div>
      <div class="nims-communicationData">
        <p-row>
          <p-col>
            <p-checkbox v-model="wizardData.hasAcceptedMarketing" :label="$t('pronatura.widget.nimswizard.communicationData.hasAcceptedMarketing')"></p-checkbox>
          </p-col>
        </p-row>
      </div>
    </div>
  </prona-wizard-step>
</template>

<script lang="ts">
  import NimSRegistrationRequestViewModel from '@/src/services/v1/viewModel/resource/NimSRegistrationRequestViewModel';
  import Vue from 'vue';

  export default Vue.extend({
    name: 'WizardStepNimSContactData',
    props: {
      value: { type: Object, default: undefined },
    },
    data: () => ({
      isLoading: false,
      error: undefined as any,
      salutations: [
        { caption: Vue.$t('core.address.salutationEnum1'), id: 1 },
        { caption: Vue.$t('core.address.salutationEnum2'), id: 2 },
        { caption: Vue.$t('core.address.salutationEnum3'), id: 3 },
      ],
    }),
    computed: {
      wizardData: {
        get(): NimSRegistrationRequestViewModel {
          return this.value ?? {};
        },
        set(value: NimSRegistrationRequestViewModel) {
          this.$emit('input', value);
        },
      },
    },
    async mounted() {
      this.isLoading = true;
      await this.wizardData.loadLanguages();
      const language = this._.isSet(this.wizardData.nimSLanguageId) ? this.wizardData.nimSLanguageId : (Vue.$translation.get() ?? Vue.$config.values['language-default'] ?? this.$translation.get());

      const translatedLanguage = this.wizardData.translatedItemsList.find((l) => l.caption?.toLowerCase() === language.toLowerCase())?.id;
      this.wizardData.nimSLanguageId = translatedLanguage;
      this.isLoading = false;
    },
  });
</script>
